import React from "react"
import PropTypes from 'prop-types'
import { Route, Redirect } from "react-router-dom"
import {havePermission} from "../common/general";

const AppRoute = ({
  component: Component,
  layout: Layout,
  isAuthProtected,
  ...rest
}) => (
  <Route
    {...rest}
    render={props => {
      if (isAuthProtected && !localStorage.getItem("authUser")) {
        return (
          <Redirect to={{ pathname: "/login", state: { from: props.location } }}/>
        )
      }

      const path = props.location.pathname
      if (((path === "/simple-inbox" || path === "/simple-files") && !havePermission(4)) ||
        (((path === "/inbox" && !havePermission(20)) || (path === "/files" && !havePermission(21)) || (path === "/search"  && !havePermission(22)))) ||
        ((path === "/dashboard") && !havePermission(2)) ||
        ((path === "/companies" || path === "/sections" || path === "/segments" || path === "/users" || path === "/groups" || path === "/notifications") && !havePermission(1))) {
        return (<Redirect to={{ pathname: "/pages-404", state: { from: props.location } }}/>)
      }

      return (
        <Layout>
          <Component {...props} />
        </Layout>
      )
    }}
  />
)

AppRoute.propTypes = {
  isAuthProtected: PropTypes.bool,
  component: PropTypes.any,
  location: PropTypes.object,
  layout: PropTypes.any
}

export default AppRoute
